/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sms_Status_TimeoutInputs */

const cs_sms_status_timeout = /** @type {(inputs: Sms_Status_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načtení stavu SMS vypršelo. Zkuste to znovu.`)
};

const en_sms_status_timeout = /** @type {(inputs: Sms_Status_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading SMS status timed out. Try again.`)
};

/**
* | output |
* | --- |
* | "Loading SMS status timed out. Try again." |
*
* @param {Sms_Status_TimeoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sms_status_timeout = /** @type {((inputs?: Sms_Status_TimeoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sms_Status_TimeoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sms_status_timeout(inputs)
	return cs_sms_status_timeout(inputs)
});